import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/parts-catalog/privacy-notice")({
  head: () => pageHead({ title: 'Privacy Notice', description: 'Privacy notice for the Rex & Sons RVs parts store.', path: '/parts-catalog/privacy-notice' }),
  beforeLoad: () => {
    throw redirect({ href: "/parts-catalog/page/privacy-notice" });
  },
});
